// extracted by mini-css-extract-plugin
export var content = "reviews-description-module--content--a65e4";
export var descriptionTitle = "reviews-description-module--description-title--8a38d";
export var displayContent = "reviews-description-module--display-content--b0494";
export var productDiscription = "reviews-description-module--product-discription--b0180";
export var productIcon = "reviews-description-module--product-icon--9cf8d";